import * as Constantes from '../../../shared/constants';

// Módulos
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

// Interfaces y Modelos
import { ICliente } from 'src/app/interfaces/cliente';
import { IPedidoExterno } from 'src/app/interfaces/pedido_externo';
import { IAlmacen } from 'src/app/interfaces/almacenes';

// Servicios
import { CampanyasService } from 'src/app/services/datos/campanyas.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { PedidosExternosService } from 'src/app/services/datos/pedidosExternos.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { AlmacenesService } from 'src/app/services/datos/almacenes.service';
import { EanLabelsService } from 'src/app/services/ean-labels.service';
import { AvisosService } from 'src/app/services/datos/avisos.service';
import { FechaUtilsService } from 'src/app/services/utils/fecha-utils.service';
import { CronTotalesMenuService } from 'src/app/services/cron-totales-menu.service';
import { SidebarService } from 'src/app/services/sidebar.service';

// Librerías
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import FuncLib from 'src/app/providers/funcionesLib';

@Component({
  selector: 'app-campanya-new',
  templateUrl: './campanya-new.component.html',
  styleUrls: ['./campanya-new.component.scss'],
})
export class CampanyaNewComponent implements OnInit {

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  //Usar constantes en el template
  Constantes = Constantes;

  public campForm: FormGroup = new FormGroup({});
  public enviado: boolean = false;
  public loading: boolean = false;

  public fotoDir: string = environment.fotoDir;
  public imagenSeleccionada: string | null = null;

  public lista: IPedidoExterno[] = [];
  public clientesList: ICliente[] = [];
  public almacenesList: IAlmacen[] = [];

  public cuentaClientes: number = 0;
  public pedidosclientes: any[] = [];

  selected: any = [];
  SelectionType = SelectionType;
  selectAllRows: boolean = false;

  public rows: any = [];
  public temp: any[] = [];

  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';
  public summaryPosition: string =
    localStorage.getItem('summaryPosition') || 'bottom';
  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  textoDestacado: string = '';
  public strBuscarTodo: string = '';

  opcionesList: any = {};
  cliSeleccionado: string = '';
  almSeleccionado: string = '0';
  pedidosList: any[] = []; // Información de un pedido
  public pedidoInfo: any = {};
  campanyaTipo: string = 'Normal';
  private ctrlPrimeraVez: boolean = true;

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: `total`,
    selectedMessage: `seleccionados`,
  };

  ColumnMode = ColumnMode;
  @ViewChild(CampanyaNewComponent) table: CampanyaNewComponent | any;

  constructor(
    private fb: FormBuilder,
    private campanyaSrv: CampanyasService,
    private pedidosExternosSrv: PedidosExternosService,
    public almacenesSrv: AlmacenesService,
    private clientesSrv: ClientesService,
    private usarioSrv: UsuarioService,
    public eanLabelsSrv: EanLabelsService,
    private notificSrv: NotificacionesService,
    private avisosSrv: AvisosService,
    private fechaUtils: FechaUtilsService,
    private router: Router,
    public cronTotalesSrv: CronTotalesMenuService,
    private sidebarSrv: SidebarService
  ) {
    // Definir formulario
    this.campForm = this.fb.group({
      descripcion: [''],
    });
  }

  ngOnInit(): void {
    this.sidebarSrv.expandMenu('pedidos'); // Forzar el abrir menú de pedidos

    this.cronTotalesSrv.getTotalesApi(); // Actualizar totales en el menú

    // por defecto el almacén predeterminado para el usuario logeado
    this.almSeleccionado =
      this.usarioSrv.userdata?.alm_por_defecto?.toString() || '0';

    this.ctrlPrimeraVez = true;

    this.getClientesList();
    this.getAlmacenesList();
    this.cargaPedidosList();
  }

  cargaPedidosList() {
    this.opcionesList.id_cliente = parseInt(this.cliSeleccionado);
    this.opcionesList.id_almacen = parseInt(this.almSeleccionado);
    if (this.opcionesList.id_almacen === 0) this.opcionesList.id_almacen = null;
    this.opcionesList.fecha_carga_null = 1; //fecha_carga == null

    this.loading = true;
    this.pedidosExternosSrv.getLista(this.opcionesList).subscribe((resp) => {
      this.loading = false;

      console.log('__cargaPedidosList', resp);

      // Añadir el numero de pedidos a ClientesList la primera vez
      this.pedidosclientes = resp.totales.clientes;
      if (this.ctrlPrimeraVez) {
        this.setPedidosClientes();
        this.ctrlPrimeraVez = false;
      }

      this.lista = resp.data;

      this.rows = this.lista;
      this.temp = [...this.lista];
      if (resp.totales.noActualizados) {
        this.notificSrv.aviso(
          'warning',
          resp.totales.noActualizados + ' Artículos NO encontrados'
        );
      }
      if (resp.totales.contaSinStock) {
        this.notificSrv.aviso(
          'info',
          resp.totales.contaSinStock + ' Artículos SIN Stock suficiente'
        );
      }
      if (resp.totales.pedidosSinDetall) {
        this.notificSrv.aviso(
          'error',
          resp.totales.pedidosSinDetall +
          ' Cabeceras de Pedido sin líneas de detalle'
        );
      }
      if (resp.totales.pedidosSinPedCli) {
        this.notificSrv.aviso(
          'error',
          resp.totales.pedidosSinPedCli +
          ' Pedidos sin Número de pedido desde el cliente'
        );
      }
      if (resp.totales.pedidosSinIdCli) {
        this.notificSrv.aviso(
          'error',
          resp.totales.pedidosSinIdCli + ' Pedidos de clientes NO reconocidos'
        );
      }
      if (resp.totales.pedidosDuplicados) {
        this.notificSrv.aviso(
          'error',
          resp.totales.pedidosDuplicados + ' Pedidos ya existentes'
        );
      }
    });
  }

  setPedidosClientes() {
    // Crear un mapa de pedidos por cliente para búsqueda eficiente
    const pedidosPorCliente = new Map();
    if (this.pedidosclientes) {
      this.pedidosclientes.forEach(
        (item: { id_cliente: number; num_pedidos: number }) => {
          pedidosPorCliente.set(item.id_cliente, item.num_pedidos);
        }
      );
    }

    // Añadir num_pedidos a cada cliente
    this.clientesList = this.clientesList.map((cliente: any) => ({
      ...cliente,
      num_pedidos: pedidosPorCliente.get(cliente.id) || 0,
    }));
  }

  getClientesList() {
    this.clientesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }

  getAlmacenesList() {
    this.almacenesSrv.getLista().subscribe((respuesta) => {
      this.loading = false;
      this.almacenesList = respuesta.data;
    });
  }

  unoAunoClick() {
    this.campanyaTipo = '1 a 1';
    this.enviar();
  }

  enviar() {
    this.enviado = true;

    console.log('__enviar()', this.campForm);

    if (this.campForm.invalid) {
      console.log('ERRORES:', this.campForm);
      return;
    }

    // Todo ok, enviar al BackEnd

    let id_almacen: number | null = parseInt(this.almSeleccionado);
    if (id_almacen === 0) id_almacen = null;

    const datos = {
      ...this.campForm.value,
      pedidos: this.selected,
      id_almacen: id_almacen,
      campanyaTipo: this.campanyaTipo,
      fecha_entrada: new Date(),
    };

    this.loading = true;
    console.log('_campanyaNew() datos=', datos);
    this.campanyaSrv.new(datos).subscribe((resp) => {
      this.loading = false;

      console.log('_campanyaNew() resp=', resp);

      if (resp.error) {
        // this.notificacionesService.aviso('error', resp.mensaje);
        console.log(resp.mensaje);
        for (let controlName in resp.mensaje) {
          this.campForm
            .get(controlName)!
            .setErrors({ apiError: resp.mensaje[controlName] });
        }
      } else {
        this.notificSrv.aviso('success', resp.mensaje);
        this.cronTotalesSrv.getTotalesApi(); // Actualizar totales en el menú
        this.router.navigateByUrl(`panel/campanyas_lista`);
      }
    });
  }

  get f() {
    return this.campForm.controls;
  }

  // Filtros

  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
    this.cargaPedidosList();

    this.selectAllRows = false;
    this.selected = [];
    this.pedidosList = [];
    this.pedidoInfo = {};
  }

  onAlmacenSelect(id: string) {
    this.almSeleccionado = id;
    this.cargaPedidosList();

    this.selectAllRows = false;
    this.selected = [];
    this.pedidosList = [];
    this.pedidoInfo = {};
  }

  avisarCliente(event: any, row: any) {
    event.stopPropagation();
    const pedidoExt = row;
    const fechaFormateada = this.fechaUtils.formatearDdMmYyyy(
      pedidoExt.fecha_pedido
    );
    Swal.fire({
      title: '<i class="fa-solid fa-laptop"></i> Enviar notificación',
      text: `Escribe el mensaje para ${pedidoExt.cliNombre} referente a su pedido`,
      input: 'textarea',
      inputValue: `Referente al pedido ${pedidoExt.pedido_cli} de fecha ${fechaFormateada}...`,
      inputPlaceholder: 'Escribe tu mensaje aquí...',
      showCancelButton: true,
      confirmButtonText: 'Enviar notificación',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      inputValidator: (value) => {
        if (!value || value.trim().length < 4) {
          return 'El mensaje debe contener al menos 4 caracteres';
        }
        return null;
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const texto = result.value.trim();
        const data = {
          id_cliente: pedidoExt.id_cliente,
          tipo: Constantes.AVISO_TIPO_PEDIDO,
          buscar_pedido: null,
          mensaje: texto,
        };
        this.avisosSrv.avisoNew(data).subscribe((resp) => {
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notificSrv.aviso('success', resp.mensaje);
        });
      }
    });
  }

  //  ** CRUD ** //

  deleteRow(row: any) {
    Swal.fire({
      title: '¿Borrar campaña?',
      icon: 'question',
      html: `Eliminar <b>${row.descripcion}</b>`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.campanyaSrv.delete(row.id).subscribe((resp) => {
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
          } else {
            this.notificSrv.aviso('info', `Registro eliminado`);
            this.rows = this.rows.filter((objeto: any) => objeto.id !== row.id);
          }
        });
      }
    });
  }

  buscaGlobal(txt: string) {
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.pedidosList;
  }

  limpiaBusca() {
    this.strBuscarTodo = '';
    this.buscaGlobal('');
    const buscaTodoInput = document.getElementById('buscaTodo');
    buscaTodoInput?.focus();
  }
  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr); // convertir el valor a número
  }

  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    this.buscaGlobal(txt);
  }

  // Exportar a Excel
  exportToExcel(): void {
    const fileName = `pedidos-campanya-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }

  public sumaCeldas(cells: any[]) {
    // Devuelve la suma de la columna, formateada y sin decimales
    const filteredCells = cells.filter((cell) => !!cell);
    const sum: number = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue),
      0
    );
    return sum.toLocaleString('de-DE');
  }

  public cuentaCeldas(cells: any[]) {
    // Devuelve el número de filas
    const filteredCells = cells.filter((cell) => !!cell);
    const sum: number = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + 1,
      0
    );
    return sum.toLocaleString('de-DE');
  }

  noSummary() {
    return null;
  }

  // ** Selección de líneas  ** //

  onActivate(event: any) {
    // Evitar selección en caso de doble click
    if (event.type === 'dblclick') {
      event.rowElement.classList.remove('datatable-row-selected'); // Desmarca la fila

      this.filtraEstados8();
      this.setCuentaClientes();
      return;
    }

    if (event.type === 'click') {
      console.log('Activate Evento click', event);
      this.selectAllRows = false;

      this.filtraEstados8();
      this.setCuentaClientes();
      console.log('_selected.length', this.selected.length);
    }
  }

  toggleSelectAllRows() {
    // Establecer todos los elementos como seleccionados?
    const allRows = [...this.rows];

    if (this.selectAllRows) this.selected = [...allRows];
    if (!this.selectAllRows) this.selected = [];

    this.filtraEstados8();
    this.setCuentaClientes();
  }

  filtraEstados8() {
    // No seleccionar los que tengan estado == 8x
    this.selected = this.selected.filter(
      (item: { estado: number }) => !item.estado.toString().startsWith('8')
    );
  }

  setCuentaClientes() {
    this.cuentaClientes = this.selected.reduce(
      (count: { add: (arg0: any) => any }, pedido: { id_cliente: any }) => {
        return count.add(pedido.id_cliente!);
      },
      new Set<number>()
    ).size;
  }

  //** Línea de Pedidos *//

  delPedido(event: any, row: any) {
    event.stopPropagation();
    this.infoPedido(event, row);

    Swal.fire({
      title: '¿Borrar pedido del cliente?',
      icon: 'question',
      html: `Eliminar el pedido <b>${row.pedido_cli} de ${row.cliNombre}</b>`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.pedidosExternosSrv.delete(row.id).subscribe((resp) => {
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
          } else {
            this.notificSrv.aviso('info', `Registro eliminado`);
            this.rows = this.rows.filter((objeto: any) => objeto.id !== row.id);
          }
        });
      }
    });
  }

  infoPedido(event: any, row: any) {
    event.stopPropagation();
    this.pedidosList = [];
    if (row.detall) this.pedidosList = row.detall;
    this.pedidoInfo = row;

    // Destacar línea seleccionada en negrita
    this.rows.forEach((r: any) => {
      r.destacarLinea = false;
    });
    row.destacarLinea = true;

    console.log('__infoPedido', row);
  }

  // Modal imágen
  abrirPopupImagen(url: string) {
    console.log('__abrirPopupImagen()', url);
    if (url.includes('_noFoto')) return;
    this.imagenSeleccionada = url;
  }

  cerrarPopupImagen() {
    this.imagenSeleccionada = null;
  }

  get totalCantidad() {
    return this.pedidosList.reduce((acc, lin) => acc + Number(lin.cantidad || 0), 0);
  }

  get totalStock() {
    return this.pedidosList.reduce((acc, lin) => acc + Number(lin.artStock || 0), 0);
  }

  get totalReservado() {
    return this.pedidosList.reduce((acc, lin) => acc + Number(lin.stockRes || 0), 0);
  }
}
